import React, { useState } from 'react';
import { IndicateurEtapes, LoaderMi, Container } from '@si-armes/dsfr-react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import CreerCompteChoixMotif from './components/motif/CreerCompteChoixMotif';
import CreerCompteIdentite from './components/identite/CreerCompteIdentite';
import CreerCompteResponsableLegal from './components/identite/CreerCompteResponsableLegal';
import CreerCompteEtapeValidation from './components/validation/CreerCompteEtapeValidation';
import CreerCompteAdresse from './components/adresse/CreerCompteAdresse';
import CreerCompteAdresseSecondaire from './components/adresseSecondaire/CreerCompteAdresseSecondaire';
import CreerCompteAdresseSecondaireResponsableLegal from './components/adresseSecondaireResponsableLegal/CreerCompteAdresseSecondaireResponsableLegal';
import { definirComplement } from '../../../../store/titreReducer';
import StatutCompte from './components/statut/StatutCompte';
import CreerCompteIdentiteMetierAsso from './components/identite/CreerCompteIdentiteMetierAsso';
import {
    KEY_DETENTEUR_METIER_PHYSIQUE,
    KEY_DETENTEUR_COLLECTIONNEUR_PHYSIQUE,
} from './components/statut/StatutCompte.constante';
import { ETAPE_KEYS, FLOW_KEYS } from './etapesFlows.constantes';
import CoordonneesDetenteurPhysique from './components/metiersEtAssociatifs/detenteurMetierPhysique/CoordonneesDetenteurPhysique';
import InformationsPersonneMorale from './components/identite/InformationsPersonneMorale';

const CreerCompteEtape1 = ({
    featureFlipping,
    isLoadingFeatureFlipping,
    methodeDefinirComplement,
}) => {
    const [etape, setEtape] = useState(ETAPE_KEYS.MOTIF);

    const [statutMetierAsso, setStatutMetierAsso] = useState();

    const [motifs, setMotifs] = useState();
    const [identite, setIdentite] = useState();
    const [responsableLegal, setResponsableLegal] = useState();
    const [adressePrincipale, setAdressePrincipale] = useState();
    const [identiteMetierAsso, setIdentiteMetierAsso] = useState();
    const [personneMorale, setPersonneMorale] = useState();
    const [adressesSecondaires, setAdressesSecondaires] = useState([]);
    const [adressesSecondairesResponsableLegal, setAdressesSecondairesResponsableLegal] = useState(
        [],
    );
    const [uuidBrouillon, setUuidBrouillon] = useState();
    const [isAncienLicencie, setIsAncienLicencie] = useState(false);
    const [adressePrincipaleResponsableLegal, setAdressePrincipaleResponsableLegal] = useState();

    const setMotifsSelectionnes = (motifsCoches) => {
        setMotifs({
            isChasseur: motifsCoches.isChasseur,
            isLicencie: motifsCoches.isLicencie,
            isNonLicencie: motifsCoches.isNonLicencie,
            isDetenteurProfessionnel: motifsCoches.isDetenteurProfessionnel,
            isMineur: motifsCoches.isMineur,
        });
        setUuidBrouillon(motifsCoches.uuidBrouillon);

        setEtape(
            motifsCoches.isDetenteurProfessionnel
                ? ETAPE_KEYS.STATUT_METIER_ASSO
                : ETAPE_KEYS.IDENTITE,
        );
    };

    const flowMetierAsso =
        statutMetierAsso === KEY_DETENTEUR_METIER_PHYSIQUE ||
        statutMetierAsso === KEY_DETENTEUR_COLLECTIONNEUR_PHYSIQUE
            ? [
                  {
                      key: ETAPE_KEYS.IDENTITE,
                      titre: 'Identité du détenteur métier physique',
                  },
                  {
                      key: ETAPE_KEYS.COORDONNEES_PERSONNE_PHYSIQUE,
                      titre:
                          statutMetierAsso === KEY_DETENTEUR_COLLECTIONNEUR_PHYSIQUE
                              ? 'Adresse de la résidence principale et coordonnées du détenteur collectionneur personne physique'
                              : 'Adresse de la résidence principale et coordonnées',
                  },
                  {
                      key: ETAPE_KEYS.VALIDATION,
                      titre: 'Validation',
                  },
              ]
            : [
                  {
                      key: ETAPE_KEYS.IDENTITE_PERSONNE_MORALE,
                      titre: 'Identité du responsable légal',
                  },
                  {
                      key: ETAPE_KEYS.INFORMATIONS_PERSONNE_MORALE,
                      titre: "Renseignement de l'établissement",
                  },
                  {
                      key: ETAPE_KEYS.VALIDATION,
                      titre: 'Validation',
                  },
              ];

    const ETAPES_FLOWS = {
        [FLOW_KEYS.REGULAR]: [
            {
                key: ETAPE_KEYS.IDENTITE,
                titre: 'Identité',
            },
            {
                key: ETAPE_KEYS.ADRESSE_PRINCIPALE,
                titre: 'Adresse de la résidence principale et coordonnées',
            },
            {
                key: ETAPE_KEYS.ADRESSE_SECONDAIRE,
                titre: 'Adresse(s) de résidence secondaire(s) en France',
            },
            {
                key: ETAPE_KEYS.VALIDATION,
                titre: 'Validation',
            },
        ],

        [FLOW_KEYS.STATUT_METIER_ASSO]: [
            {
                key: ETAPE_KEYS.STATUT_METIER_ASSO,
                titre: 'Informations sur le statut',
            },
            ...flowMetierAsso,
        ],

        [FLOW_KEYS.MINEUR]: [
            {
                key: ETAPE_KEYS.IDENTITE,
                titre: 'Identité du détenteur mineur',
            },
            {
                key: ETAPE_KEYS.IDENTITE_RESPONSABLE_LEGAL,
                titre: 'Identité du responsable légal du détenteur mineur',
            },
            {
                key: ETAPE_KEYS.ADRESSE_PRINCIPALE,
                titre: 'Adresse de la résidence principale et coordonnées du détenteur mineur',
            },
            {
                key: ETAPE_KEYS.ADRESSE_SECONDAIRE,
                titre: 'Adresse de résidence secondaire du détenteur mineur',
            },
            {
                key: ETAPE_KEYS.ADRESSE_PRINCIPALE_RESPONSABLE_LEGAL,
                titre: 'Adresse de résidence principale du responsable légal du détenteur mineur',
            },
            {
                key: ETAPE_KEYS.ADRESSE_SECONDAIRE_RESPONSABLE_LEGAL,
                titre: 'Adresse de résidence secondaire du responsable légal du détenteur mineur',
            },
            {
                key: ETAPE_KEYS.VALIDATION,
                titre: 'Validation',
            },
        ],
    };

    const STEPPER_FLOWS = Object.fromEntries(
        Object.entries(ETAPES_FLOWS).map(([flowKey, etapes]) => [
            flowKey,
            etapes.reduce((acc, { key }, index) => {
                acc[key] = index + 1;
                return acc;
            }, {}),
        ]),
    );

    const getFlowKey = () => {
        if (!motifs) {
            return FLOW_KEYS.REGULAR;
        }
        if (motifs.isDetenteurProfessionnel === true) {
            return FLOW_KEYS.STATUT_METIER_ASSO;
        }
        if (motifs.isMineur === true) {
            return FLOW_KEYS.MINEUR;
        }
        return FLOW_KEYS.REGULAR;
    };

    const flowKey = getFlowKey();

    const etapeStepper = STEPPER_FLOWS[flowKey][etape] ?? 0;

    const etapes = ETAPES_FLOWS[flowKey].map((etapeItem, index) => ({
        id: index + 1,
        ...etapeItem,
    }));

    const totalSteps = Object.keys(STEPPER_FLOWS[flowKey]).length;

    React.useEffect(() => {
        if (etapeStepper > 0) {
            methodeDefinirComplement(`étape ${etapeStepper} sur ${totalSteps}`);
        }
    }, [etape, etapeStepper, statutMetierAsso]);

    const choisirEtape = (index = 1) => {
        const result = etapes.find((item) => item.id === etapeStepper + index);

        if (result) {
            setEtape(result.key);
        }
    };

    const retourSelectionsMotifs = () => {
        setUuidBrouillon(null);
        setEtape(ETAPE_KEYS.MOTIF);
    };

    const setEtapeAdressePrincipale = (dataAdressePrincipale) => {
        setAdressePrincipale(dataAdressePrincipale);
        // Changer étape
        choisirEtape();
    };

    const setEtapeInformationPersonneMorale = (dataPersonneMorale) => {
        setPersonneMorale(dataPersonneMorale);
        choisirEtape();
    };

    const retourEtapeDeAdressesSecondaires = (dataAdressesSecondaires) => {
        setAdressesSecondaires(dataAdressesSecondaires);
        // Changer étape
        choisirEtape(-1);
    };

    const setEtapeAdressesSecondaires = (dataAdressesSecondaires) => {
        setAdressesSecondaires(dataAdressesSecondaires);
        // Changer étape
        choisirEtape();
    };

    const setEtapeValidation = () => {
        // Changer étape
        setEtape(ETAPE_KEYS.VALIDATION_EMAIL);
    };

    const setAncienLicencie = (ancienLicencie) => {
        setIsAncienLicencie(ancienLicencie);
    };

    const setEtapeIdentiteMetierAsso = (dataIdentiteMetierAsso) => {
        setIdentiteMetierAsso(dataIdentiteMetierAsso);
        // Changer étape
        choisirEtape();
    };

    const setEtapeCoordonnees = (dataAdressePrincipale, dataAdressesSecondaires) => {
        setAdressePrincipale(dataAdressePrincipale);
        setAdressesSecondaires(dataAdressesSecondaires);
        choisirEtape();
    };

    const retourEtapeCoordonnees = (dataAdressesSecondaires) => {
        setAdressesSecondaires(dataAdressesSecondaires);
        // Changer étape
        choisirEtape(-1);
    };

    const setEtapeIdentite = (dataIdentite) => {
        setIdentite(dataIdentite);
        // Changer étape
        choisirEtape();
    };

    const setEtapeResponsableLegal = (dataResponsableLegal) => {
        setResponsableLegal(dataResponsableLegal);
        // Changer étape
        choisirEtape();
    };

    const setEtapeAdressePrincipaleResponsableLegal = (dataAdressePrincipaleResponsableLegal) => {
        setAdressePrincipaleResponsableLegal(dataAdressePrincipaleResponsableLegal);
        choisirEtape();
    };

    const retourEtapeDeAdressesSecondairesResponsableLegal = (
        dataAdressesSecondairesResponsableLegal,
    ) => {
        setAdressesSecondairesResponsableLegal(dataAdressesSecondairesResponsableLegal);
        choisirEtape(-1);
    };

    const setEtapeAdressesSecondairesResponsableLegal = (
        dataAdressesSecondairesResponsableLegal,
    ) => {
        setAdressesSecondairesResponsableLegal(dataAdressesSecondairesResponsableLegal);
        choisirEtape();
    };

    return (
        <>
            {isLoadingFeatureFlipping && <LoaderMi taille="md" />}
            {etape === ETAPE_KEYS.MOTIF && featureFlipping && (
                <CreerCompteChoixMotif
                    motifsSelectionnes={motifs}
                    setMotifsSelectionnes={setMotifsSelectionnes}
                    featureFlipping={featureFlipping}
                />
            )}
            {uuidBrouillon && etape !== 'validation-mail' && (
                <Container>
                    <h1
                        aria-label="Création de compte - Première partie (1 sur 2)"
                        className="text-center"
                        data-testid="account-creation-step1-title"
                    >
                        Création de compte - Première partie (1/2)
                    </h1>
                    <IndicateurEtapes
                        etapeEnCours={etapeStepper}
                        nombreEtapes={totalSteps}
                        titreEtapeEnCours={etapes.find((step) => step.id === etapeStepper)?.titre}
                        titreProchaineEtape={
                            etapeStepper < totalSteps
                                ? etapes.find((step) => step.id === etapeStepper + 1).titre
                                : null
                        }
                    />
                    {etape === ETAPE_KEYS.STATUT_METIER_ASSO && (
                        <StatutCompte
                            setStatutMetierAsso={setStatutMetierAsso}
                            setEtape={setEtape}
                            retourEtape={retourSelectionsMotifs}
                            choisirEtape={choisirEtape}
                        />
                    )}
                    {etape === ETAPE_KEYS.IDENTITE && (
                        <CreerCompteIdentite
                            motifs={motifs}
                            uuidBrouillon={uuidBrouillon}
                            dataIdentiteRenseignee={identite}
                            setEtapeIdentite={setEtapeIdentite}
                            retourEtape={retourSelectionsMotifs}
                            setAncienLicencie={setAncienLicencie}
                            featureFlipping={featureFlipping}
                        />
                    )}

                    {/* étape 2 mineur : identite responsable legal */}
                    {etape === ETAPE_KEYS.IDENTITE_RESPONSABLE_LEGAL && (
                        <CreerCompteResponsableLegal
                            dataResponsableLegalRenseignee={responsableLegal}
                            setEtapeResponsableLegal={setEtapeResponsableLegal}
                            retourEtape={() => choisirEtape(-1)}
                            uuidBrouillon={uuidBrouillon}
                        />
                    )}

                    {/* etape 2 personne morale */}
                    {etape === ETAPE_KEYS.IDENTITE_PERSONNE_MORALE && (
                        <CreerCompteIdentiteMetierAsso
                            motifs={motifs}
                            uuidBrouillon={uuidBrouillon}
                            setEtapeIdentite={setEtapeIdentite}
                            setAncienLicencie={setAncienLicencie}
                            featureFlipping={featureFlipping}
                            dataIdentiteMetierAsso={identiteMetierAsso}
                            retourEtape={() => {
                                choisirEtape(-1);
                            }}
                            isAncienLicencie={false}
                            setEtapeIdentiteMetierAsso={setEtapeIdentiteMetierAsso}
                            statutMetierAsso={statutMetierAsso}
                        />
                    )}

                    {/* etape 3  personne morale */}
                    {etape === ETAPE_KEYS.INFORMATIONS_PERSONNE_MORALE && (
                        <InformationsPersonneMorale
                            uuidBrouillon={uuidBrouillon}
                            setEtapeInformationPersonneMorale={setEtapeInformationPersonneMorale}
                            dataInformationsPersonneMorale={personneMorale}
                            retourEtape={() => choisirEtape(-1)}
                        />
                    )}

                    {etape === ETAPE_KEYS.COORDONNEES_PERSONNE_PHYSIQUE && (
                        <CoordonneesDetenteurPhysique
                            uuidBrouillon={uuidBrouillon}
                            dataAdressePrincipaleRenseignee={adressePrincipale}
                            dataAdressesSecondairesRenseignee={adressesSecondaires}
                            setEtapeCoordonnees={setEtapeCoordonnees}
                            retourEtape={retourEtapeCoordonnees}
                        />
                    )}

                    {etape === ETAPE_KEYS.ADRESSE_PRINCIPALE && (
                        <CreerCompteAdresse
                            motifs={motifs}
                            uuidBrouillon={uuidBrouillon}
                            dataAdressePrincipaleRenseignee={adressePrincipale}
                            setEtapeAdresse={setEtapeAdressePrincipale}
                            retourEtape={() => choisirEtape(-1)}
                            isAncienLicencie={isAncienLicencie}
                        />
                    )}
                    {etape === ETAPE_KEYS.ADRESSE_SECONDAIRE && (
                        <CreerCompteAdresseSecondaire
                            uuidBrouillon={uuidBrouillon}
                            dataAdressesSecondairesRenseignee={adressesSecondaires}
                            setEtapeAdresse={setEtapeAdressesSecondaires}
                            retourEtape={retourEtapeDeAdressesSecondaires}
                        />
                    )}

                    {/* étape 5 mineur : adresse principale responsable legal */}
                    {etape === ETAPE_KEYS.ADRESSE_PRINCIPALE_RESPONSABLE_LEGAL && (
                        <CreerCompteAdresse
                            motifs={motifs}
                            uuidBrouillon={uuidBrouillon}
                            dataAdressePrincipaleRenseignee={adressePrincipaleResponsableLegal}
                            setEtapeAdresse={setEtapeAdressePrincipaleResponsableLegal}
                            retourEtape={() => choisirEtape(-1)}
                            isResponsableLegal
                            adresseMineur={adressePrincipale}
                            isAncienLicencie={isAncienLicencie}
                        />
                    )}

                    {etape === ETAPE_KEYS.ADRESSE_SECONDAIRE_RESPONSABLE_LEGAL && (
                        <CreerCompteAdresseSecondaireResponsableLegal
                            uuidBrouillon={uuidBrouillon}
                            dataAdressesSecondairesRenseignee={adressesSecondairesResponsableLegal}
                            setEtapeAdresse={setEtapeAdressesSecondairesResponsableLegal}
                            retourEtape={retourEtapeDeAdressesSecondairesResponsableLegal}
                            adressesSecondairesDuMineur={adressesSecondaires}
                        />
                    )}

                    {etape === ETAPE_KEYS.VALIDATION && (
                        <CreerCompteEtapeValidation
                            setEtapeValidation={setEtapeValidation}
                            uuidBrouillon={uuidBrouillon}
                            retourEtape={() => choisirEtape(-1)}
                        />
                    )}
                </Container>
            )}
            {uuidBrouillon && etape === ETAPE_KEYS.VALIDATION_EMAIL && (
                <Container>
                    <h1 data-testid="creation-success">
                        Finalisation de la création de votre compte
                    </h1>
                    <div>
                        <p>
                            Pour finaliser la création de votre compte, veuillez cliquer sur le lien
                            du mail que vous venez de recevoir.
                        </p>
                        <p>
                            Si vous n'avez pas le mail dans votre boîte de réception, vérifiez que
                            ce message n'est pas dans votre dossier « spam » ou « courrier
                            indésirable ».
                        </p>
                        <p>
                            Si vous ne trouvez pas ce mail, veuillez prendre contact avec votre
                            préfecture via le formulaire de contact situé en bas de cet écran en
                            cliquant sur <strong>"Nous contacter"</strong>.
                        </p>
                    </div>
                </Container>
            )}
        </>
    );
};

CreerCompteEtape1.propTypes = {
    featureFlipping: PropTypes.object,
    isLoadingFeatureFlipping: PropTypes.bool,
    methodeDefinirComplement: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const { data: featureFlipping, isLoading: isLoadingFeatureFlipping } =
            state.featureFlipping;
        return {
            featureFlipping,
            isLoadingFeatureFlipping,
        };
    },
    {
        methodeDefinirComplement: definirComplement,
    },
)(CreerCompteEtape1);
